import styled from 'styled-components';

export const BiddingStatus = styled.span`
  [class*='bidding-situation-'] {
    background-color: ${(props) => props.theme.$gray600};
    color: ${(props) => props.theme.$white};
    padding: 3px 7px;
  }
  .bidding-situation-nova {
    background-color: ${(props) => props.theme.$primary_green};
  }
  .bidding-situation-suspensa {
    background-color: ${(props) => props.theme.$warning};
  }
  .bidding-situation-suspensa-sine-die {
    background-color: ${(props) => props.theme.$warning};
  }
  .bidding-situation-urgente {
    background-color: ${(props) => props.theme.$danger};
  }
`;
